import Quill from "quill";

const Module = Quill.import("core/module");

class TableModule extends Module {
  constructor(quill, options) {
    super(quill, options);

    const toolbar = quill.getModule("toolbar");
    if (toolbar) {
      toolbar.addHandler("insertTable", this.insertTable.bind(this));
    }
  }

  insertTable(rows = 2, cols = 2) {
    const quill = this.quill;
    const range = quill.getSelection();

    if (!range) return;

    let tableHtml = "<table style='border-collapse: collapse; width: 100%;'>";
    for (let i = 0; i < rows; i++) {
      tableHtml += "<tr>";
      for (let j = 0; j < cols; j++) {
        tableHtml +=
          "<td style='border: 1px solid #ccc; padding: 8px;'><br/></td>";
      }
      tableHtml += "</tr>";
    }
    tableHtml += "</table>";

    // Use `clipboard.dangerouslyPasteHTML` to insert the table
    quill.clipboard.dangerouslyPasteHTML(range.index, tableHtml);
    quill.setSelection(range.index + 1);
  }
}

// Register the module
Quill.register("modules/table", TableModule);



// WEBPACK FOOTER //
// ./src/component/admin/TableModule.js